import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_CALLBACKS } from "./actionTypes";
import { getCallbacksSuccess, getCallbacksError } from "./actions";

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();

function* getCallbacks({ payload: { user } }) {
  try {
    const response = yield call(
      tasksAPI.getCallbacksPending,
      user.name,
      user.token
    );
    yield put(getCallbacksSuccess(response.pendingCallbacks, response.message));
  } catch (error) {
    yield put(getCallbacksError(error));
  }
}

export function* watchGetCallbacks() {
  yield takeEvery(GET_CALLBACKS, getCallbacks);
}

function* getCallbacksSaga() {
  yield all([fork(watchGetCallbacks)]);
}

export default getCallbacksSaga;
